/* eslint-disable */
/* tslint:disable */
import React from 'react';
export default (function (_a) {
    var style = _a.style;
    return (React.createElement("svg", { className: "slideshow-arrow", style: style, width: "26px", height: "40px", viewBox: "0 0 26 40", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-35.000000, -28.000000)", fillRule: "nonzero" },
                React.createElement("polygon", { points: "60.4571429 47.8 40.6571429 67.6 35 61.9428571 49.1433951 47.7994621 35 33.6571429 40.6571429 28" })))));
});
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=arrow6.js.map